export var AVAILABLE = 'available';
export var RESERVED = 'reserved';